import { EditConsents } from '../components/EditConsents';

export const EditConsentsContainer = () => <EditConsents />;
